import { FinancialForecastEntry } from "./financials.forecast.entities";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../shared/scripts/table-column-visibility";
import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";

export class FinancialForecastTable {

    tableColumnController: TableColumnVisibilityController;


    constructor(forecastData: FinancialForecastEntry[]) {

        return this.initializeDataTable("forecast-table", forecastData);
    }

    initializeDataTable(tableId: string, data: FinancialForecastEntry[]) {
        let tableWrapperId: string = tableId + "_wrapper";
        let columns: any[] = [
            { data: "Platform", title: "Protocol", className: "platform text-left font-size12 nowrap" },
            { data: "Category", title: "Category", className: "category text-left font-size12 nowrap" },
            { data: "Projection_Date_Display", title: "Month/Year", className: "month text-left font-size12 nowrap" },
            { data: "Within_Month_Proj_Spend_Display", title: "Monthly:<br>Dollars", className: "within-month-spending text-left font-size12 nowrap" },
            { data: "Within_Month_Proj_Units_Display", title: "Monthly:<br>Units", className: "within-month-units text-left font-size12 nowrap" },
            { data: "Projected_Spending_Display", title: "Cumulative Forecast:<br>Dollars", className: "projected-spending text-left font-size12 nowrap" },
            { data: "Projected_Units_Display", title: "Cumulative Forecast:<br>Units", className: "projected-units text-left font-size12 nowrap" },
            { data: "Billed_to_Date_Display", title: "Invoiced To Date:<br>Dollars", className: "billed-to-date text-left font-size12 nowrap" },
            { data: "cost_budgeted_Display", title: "Cost Budgeted:<br>Dollars", className: "cost-budgeted text-left font-size12 nowrap" },
            { data: "units_budgeted_Display", title: "Cost Budgeted:<br>Units", className: "units-budgeted text-left font-size12 nowrap" },
            { data: "isOverspent_Display", title: "Overspent", className: "overspent text-left font-size12 nowrap" },
            { data: "Overspending_Cost_Display", title: "Overspend:<br>Dollars", className: "overspending-cost text-left font-size12 nowrap" },
            { data: "IdSort", title: "idSort", className: "idsort text-left font-size12 nowrap" },



        ];

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Protocol", true, [], "platform"),
            new TableColumnGroup("Category", true, [], "category"),
            new TableColumnGroup("Month/Year", true, [], "month"),
            new TableColumnGroup("Monthly: Dollars", true, [], "within-month-spending"),
            new TableColumnGroup("Monthly: Units", true, [], "within-month-units"),
            new TableColumnGroup("Projected: Dollars", true, [], "projected-spending"),
            new TableColumnGroup("Projected: Units", false, [], "projected-units"),
            new TableColumnGroup("Invoiced To Date: Dollars", true, [], "billed-to-date"),
            new TableColumnGroup("Cost Budgeted: Dollars", true, [], "cost-budgeted"),
            new TableColumnGroup("Cost Budgeted: Units", false, [], "units-budgeted"),
            new TableColumnGroup("Overspent", false, [], "overspent"),
            new TableColumnGroup("Overspend: Dollars", false, [], "overspending-cost"),
        ];

        let dataTable: any = $('#' + tableId).DataTable({
            retrieve: true,
            columnDefs: [
                { targets: [12], visible: false },
                {
                    targets: [2],
                    data: 'Projection_Date_Display',
                    render: function (data, type, row, meta) {
                        if (type === 'sort' || type === 'type') {
                            return row.IdSort;
                        }
                        if (type === 'display') {
                            // Manipulate your display data
                            return row.Projection_Date_Display;
                        }
                        return data;
                    }
                }
            ],
            "dom": '<"top-controls"<"column-select"><"selection-dropdown"><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            //scrollY: '70vh',
            //scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Invoices Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            //createdRow: (row, data: any, index) => {
            //    //cell formatting on percentages
            //    this.setCellPercentValue(row, 'td.overspending-cost', this.getCellColorByValue(data.Overspending_Cost), 100);
            //},
            order: [
                [0, 'asc'],
                [12, 'asc']
            ],
            data: data
        });

        $("#" + tableWrapperId + " .top-controls").addClass('row mx-0 spend-controls');

        $("#" + tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + tableWrapperId + " .column-select").empty().html('<div id="' + tableId + '-column-select"></div>');

        $("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        //$("#" + tableWrapperId + " .spacer1").addClass('col-12 col-md-3 nav-spacer');
        $("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        $("#" + tableWrapperId + " .selection-dropdown").empty().html(`<label class="mb-0">Forecast Type</label>
                                                                        <select id="forecastTypeSelect" class="forecast-type-dropdown" onchange="page.updateForecastTable(this.value)">
                                                                            <option value="PE">Enrollment Forecast</option>
                                                                            <option value="TE">Enrollment Trends</option>
                                                                        </select>`);
        $("#" + tableWrapperId + " .selection-dropdown").addClass('col-12 col-md-3 px-0 px-md-2 selection-dropdown');

        this.tableColumnController = new TableColumnVisibilityController(tableId, (tableId + '-column-select'), tableColumnGroups);

        $('#' + tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(dataTable.rows({ search: 'applied' }).count(), tableId);
        });
        this.setCountFoundLabel(data.length, tableId);

        $("#spend-tab").on('click', () => {
            setTimeout(() => {
                dataTable.columns.adjust().draw();
            }, 500)
        });
        return dataTable;
    }


    setCountFoundLabel(count: number, tableId: string): void {

        switch (count) {
            case 0: $('#' + tableId + '-found-count').text("No Entries Found"); break;
            case 1: $('#' + tableId + '-found-count').text("1 Entry Found"); break;
            default: $('#' + tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Entries Found");
        }
    }

    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).css('font-weight', "bold");
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }

    private getCellColorByValue(value: number): string {
        if (value <= 0) return "#7fb87f";
        else if (value >= 50000) return "#f07d7d";
        else return "#fce77d";

    }
}